import { render, staticRenderFns } from "./HorseCare.vue?vue&type=template&id=2dad9b3a"
import script from "./HorseCare.vue?vue&type=script&lang=js"
export * from "./HorseCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports